import styled from 'styled-components';

export const ColumnFour = styled.div`
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;

  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;

  @media (min-width: 1200px) {
    flex: 0 0 25%;
    max-width: 25%;
  }

  @media (max-width: 992px) {
    flex: 0 0 50%;
    max-width: 50%;
  }

  @media (max-width: 575px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
`;

export const ColumnThree = styled.div`
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;

  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;

  @media (min-width: 992px) {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }

  @media (max-width: 991px) {
    flex: 0 0 100%;
    max-width: 100%;
  }

  @media (max-width: 575px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
`;

export const ColumnTwo = styled.div`
  flex: 0 0 50%;
  max-width: 50%;
  display: flex;

  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;

  @media (max-width: 991px) {
    flex: 0 0 100%;
    max-width: 100%;
  }

  // @media (min-width: 576px) {
  //     display:flex;
  //     flex: 0 0 0%;
  //     max-width: 50%;
  // }

  @media (max-width: 575px) {
    display: flex;
    flex: 0 0 100%;
    max-width: 100%;

    &.justify_cntr {
      justify-content: center;
    }
  }

  &.no-gutters {
    padding-left: 0px;
    padding-right: 0px;
  }
`;

export const Column = styled.div`
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;

  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;

  &.padding-lr-zeromd {
    @media (min-width: 993px) {
      padding-left: 0px;
      padding-right: 0px;
    }
  }
`;

export const ColumnSeven = styled.div`
  flex: 0 0 58.33333%;
  max-width: 58.33333%;

  @media (max-width: 992px) {
    flex: 0 0 100%;
    max-width: 100%;
  }

  @media (max-width: 575px) {
    flex: 0 0 100%;
    max-width: 100%;
    padding-left: 15px;
    padding-right: 15px;
  }

  &.padding_lftrgt {
    position: relative;
    width: 100%;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
  }
`;

export const ColumnFive = styled.div`
  flex: 0 0 41.66667%;
  max-width: 41.66667%;
  display: flex;

  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;

  @media (max-width: 768px) {
    flex: 0 0 100%;
    max-width: 100%;
  }

  &.offset_md_1 {
    margin-left: 8.33333%;
    @media (max-width: 768px) {
      margin-left: 0px;
    }
  }
`;

export const ColumnEight = styled.div`
  flex: 0 0 66.66667%;
  max-width: 66.66667%;
  display: flex;

  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;

  &.margin_auto {
    margin-left: auto;
    margin-right: auto;
  }

  &.padding-lr-zero {
    padding-left: 0px;
    padding-right: 0px;
  }

  @media (max-width: 768px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
`;

export const ColumnMdEight = styled.div`
  @media (min-width: 992px) {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
    display: flex;
  }

  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;

  &.margin_auto {
    margin-left: auto;
    margin-right: auto;
  }

  &.padding-lr-zero {
    padding-left: 0px;
    padding-right: 0px;
  }
`;

export const ColumnTen = styled.div`
  flex: 0 0 83.33333%;
  max-width: 83.33333%;
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;

  @media (max-width: 768px) {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }

  @media (max-width: 575px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
`;

export const ColumnMdTen = styled.div`
  @media (min-width: 768px) {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }

  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;

  &.experience_section {
    @media (max-width: 768px) {
      padding-right: 0px;
      padding-left: 0px;
    }

    @media (max-width: 576px) {
      padding-right: 15px;
      padding-left: 15px;
    }
  }

  #less:before {
    content: '';
    height: 100px;
    margin-top: -100px;
    display: block;
    visibility: hidden;

    @media (min-width: 768px) {
      ${({ isNavOpen }) =>
        isNavOpen ? `height: 150px; margin-top: -150px;` : `height: 25px; margin-top: -25px;`}
    }
  }

  #greater:before {
    content: '';
    height: 100px;
    margin-top: -100px;
    display: block;
    visibility: hidden;

    @media (min-width: 768px) {
      ${({ isNavOpen }) =>
        isNavOpen ? `height: 150px; margin-top: -150px;` : `height: 25px; margin-top: -25px;`}
    }
  }

  #between:before {
    content: '';
    height: 100px;
    margin-top: -100px;
    display: block;
    visibility: hidden;

    @media (min-width: 768px) {
      ${({ isNavOpen }) =>
        isNavOpen ? `height: 150px; margin-top: -150px;` : `height: 25px; margin-top: -25px;`}
    }
  }
`;

export const ColumnSevenLgSixMdFul = styled.div`
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;

  @media (min-width: 992px) {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  @media (max-width: 768px) {
    flex: 0 0 100%;
    max-width: 100%;
  }

  @media (max-width: 575px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
`;

export const ColumnSevenXlSixlg = styled.div`
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;

  @media (min-width: 992px) {
    flex: 0 0 50%;
    max-width: 50%;
  }

  @media (max-width: 575px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
`;

export const ColumnFiveLgSixMdFul = styled.div`
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;

  @media (min-width: 992px) {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  @media (max-width: 768px) {
    flex: 0 0 100%;
    max-width: 100%;
  }

  @media (max-width: 575px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
`;

export const Innercontent = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  width: 80%;
  margin: 0 auto;
  height: 100%;

  @media (max-width: 1200px) {
    width: 100%;
  }

  @media (max-width: 992px) {
    width: 100%;
  }

  @media (max-width: 575px) {
    width: 100%;
    justify-content: inherit;
    padding-left: 15px;
    padding-right: 15px;
  }

  &.text-content {
    @media (max-width: 1199.98px) {
      width: 100%;
    }

    @media (max-width: 991.98px) {
      padding: 3rem 0;
      width: 100%;
    }

    @media (max-width: 767.98px) {
      padding: 2rem 0;
    }
  }

  &.margin-left0 {
    margin-left: 0px;
  }
  &.content_wrapper {
    margin-left: ${({ dir }) => (dir === 'rtl' ? '0px!important' : '')};
    margin-right: ${({ dir }) => (dir === 'rtl' ? '0px!important' : '')};
  }

  h3 {
    &[dir='rtl'] {
      font-family: 'GEAwtarDWTCMedium';
    }

    &[dir='ltr'] {
      font-family: 'LibreBaskervilleRegular';
    }

    @media (max-width: 1199.98px) {
      font-size: 18px;
    }

    @media (min-width: 768px) {
      font-size: ${({ dir }) => (dir === 'rtl' ? '30px' : '20px')};
      line-height: ${({ dir }) => (dir === 'rtl' ? '50px!important' : '30px')};
    }

    @media (max-width: 767.98px) {
      font-size: ${({ dir }) => (dir === 'rtl' ? '20px' : '16px')};
    }
  }

  p {
    margin-bottom: 1.5rem;
    &[dir='rtl'] {
      font-family: GESSTwoDWTCLight, sans-serif;
    }
    &[dir='ltr'] {
      font-family: 'DINRegular';
    }
  }

  &.newdevelopmentcontent {
    h3 {
      font-family: ${({ dir }) => (dir === 'rtl' ? 'GEAwtarDWTCMedium,sans-serif ' : '')};
    }
    @media (max-width: 991.98px) {
      padding: 3rem 0;
      width: 100%;
    }

    @media (max-width: 767.98px) {
      padding: 2rem 0;
    }
  }
`;

export const Innercontentp = styled.p`
  margin-bottom: 1.5rem;

  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif ' : 'DINRegular ')};

  a {
    &:hover {
      text-decoration: underline;
      color: #1b7bdd;
    }
  }
  &.toggle {
    animation-duration: 300ms;
    animation-fill-mode: forwards;
    animation-timing-function: ease-in-out;
    ${({ toggle }) =>
      toggle
        ? `
      animation-name: fadeDown;
      `
        : `
      animation-name: fadeUp;
      `}

    @media (min-width: 576px) {
      animation: none;
    }
  }

  @keyframes fadeUp {
    0% {
      height: fit-content;
      margin: 0.5rem 0;
      opacity: 1;
    }

    100% {
      opacity: 0;
      background: transparent;
      overflow: hidden;
      margin: 0;
      height: 0;
    }
  }

  @keyframes fadeDown {
    0% {
      background: transparent;
      overflow: hidden;
      margin: 0;
      height: 0;
      opacity: 0;
    }

    100% {
      height: fit-content;
      margin: 0.5rem 0;
      opacity: 1;
    }
  }
`;

export const ColumnForm = styled.div`
  @media (min-width: 992px) {
    flex: 0 0 50%;
    max-width: 50%;
  }

  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
`;

export const ColumnSixMd = styled.div`
  @media (min-width: 768px) {
    flex: 0 0 50%;
    max-width: 50%;
  }

  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  min-height: 1px;
`;

export const ColumnCardFour = styled.div`
  @media (min-width: 1200px) {
    flex: 0 0 25%;
    max-width: 25%;
  }

  @media (max-width: 1099px) {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  @media (max-width: 768px) {
    flex: 0 0 50%;
    max-width: 50%;
  }

  @media (max-width: 576px) {
    flex: 0 0 100%;
    max-width: 100%;
  }

  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
`;

export const ColumnButtonFour = styled.div`
  @media (min-width: 768px) {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  @media (max-width: 576px) {
    flex: 0 0 100%;
    max-width: 100%;
  }

  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;

  &.download-filebtn {
    .btn_breadcrumn {
      @media (max-width: 767.98px) {
        margin-top: 0px;
      }
    }
  }
`;

export const ColumnXlSevenLgSix = styled.div`
  @media (min-width: 992px) {
    flex: 0 0 50%;
    max-width: 50%;
  }

  @media (min-width: 1200px) {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
`;

export const ColumnXlSixLgFiveMdFour = styled.div`
  @media (min-width: 768px) {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  @media (min-width: 992px) {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  @media (min-width: 1200px) {
    flex: 0 0 50%;
    max-width: 50%;
  }

  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
`;
export const ColumnXlSixLgSevenMdEight = styled.div`
  @media (min-width: 768px) {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }

  @media (min-width: 992px) {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  @media (min-width: 1200px) {
    flex: 0 0 50%;
    max-width: 50%;
  }

  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
`;

export const ColumnFiveMd = styled.div`
  @media (min-width: 768px) {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;

  &.offset_md_1 {
    @media (min-width: 768px) {
      margin-left: 8.33333%;
    }
  }
`;

export const ColumnEightMd = styled.div`
  @media (min-width: 768px) {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }

  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;

  &.margin_auto {
    margin-left: auto;
    margin-right: auto;
  }
  &.padding-lr-zero {
    padding-left: 0px;
    padding-right: 0px;
  }
`;

export const ColumnSevenLgSixMd = styled.div`
  @media (min-width: 992px) {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  @media (min-width: 768px) {
    flex: 0 0 50%;
    max-width: 50%;
  }

  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;

  &.medium-card {
    @media (min-width: 992px) {
      min-width: 58.33333% !important;
    }
  }
`;

export const ColumnFiveLgSixMd = styled.div`
  @media (min-width: 992px) {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  @media (min-width: 768px) {
    flex: 0 0 50%;
    max-width: 50%;
  }

  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;

  &.small-card {
    @media (min-width: 992px) {
      max-width: 41.66667% !important;
    }
  }
`;

export const ColumnXlSevenlgSix = styled.div`
  @media (min-width: 992px) {
    flex: 0 0 50%;
    max-width: 50%;
  }

  @media (min-width: 1200px) {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
`;

export const ColumnXlThreeLgFourSmSix = styled.div`
  @media (min-width: 576px) {
    flex: 0 0 50%;
    max-width: 50%;
  }

  @media (min-width: 992px) {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  @media (min-width: 1200px) {
    flex: 0 0 25%;
    max-width: 25%;
  }

  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
`;

export const ColumnMdEightSmTwelve = styled.div`
  @media (min-width: 576px) {
    flex: 0 0 100%;
    max-width: 100%;
  }

  @media (min-width: 768px) {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }

  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
`;

export const ColumnXlFiveLgSix = styled.div`
  @media (min-width: 992px) {
    flex: 0 0 50%;
    max-width: 50%;
  }

  @media (min-width: 1200px) {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
`;
